module.exports = __webpack_public_path__ + "static/media/onboard-6-totals.f042449a.gif";